import { jsx as _jsx } from "react/jsx-runtime";
import DropdownMenu from "../DropdownMenu/index.js";
import s from "./Select.module.css";
const SelectOption = (props) => {
    const { value, ...menuItemProps } = props;
    return (_jsx(DropdownMenu.Item, { ...menuItemProps, className: [menuItemProps.className, s.option], color: "neutral", attributes: {
            ...menuItemProps.attributes,
            value,
            role: "option",
        } }));
};
SelectOption.displayName = "Select.Option";
export default SelectOption;
